import { PREDICATE_SUBSCRIBER, VALUE_EXPRESSION, PREDICATE_MACROS, INFERENCE, GRAPH_TRIGGER } from './EventsPage';

export default class EventCalculation {

  static getEventCount = (events, type, pids) => {
    let count = 0;

    switch (type) {
      case PREDICATE_SUBSCRIBER:
      case VALUE_EXPRESSION:
        Object.keys(events[type]).forEach(cid => {
          events[type][cid].forEach(event => {
            if (EventCalculation.isMatchedPredicateSubOrValueExp(event, pids)) count++;
          });
        });

        break;
      case INFERENCE:
        Object.keys(events[type]).forEach(cid => {
          events[type][cid].forEach(event => {
            if (EventCalculation.isMatchedGraphTrigger(event, pids)) count++;
          });
        });

        break;
      case GRAPH_TRIGGER:
        if (events[type]) {
          for (const event of events[type]) {
            if (EventCalculation.isMatchedGraphTrigger(event, pids)) count++;
          }
        }

        break;
      case PREDICATE_MACROS:
        Object.keys(events[type]).forEach(cid => {
          events[type][cid].forEach(event => {
            if (EventCalculation.isMatchedPredicateMacros(event, pids)) count++;
          });
        });

        break;
      default:
        break;
    }
    return count;
  };

  static isMatchedPredicateSubOrValueExp = (event, pids) => {
    let isMatched;

    if (pids.length === 1 && event['subscriber'] === +pids[0]) {
      isMatched = true;
    } else if (event['triggers']) {
      for (let trigger of event['triggers']) {
        isMatched = EventCalculation.isMatchedTrigger(trigger['pidsChain'], pids);
        if (isMatched) break;
      }
    }

    if (!isMatched) isMatched = EventCalculation.isMatchedWithPidChainsInMacro(event, pids);

    return isMatched;
  };

  static isMatchedGraphTrigger = (event, pids) => {
    let isMatched = event['trigger'] && event['trigger']['trpls']
      && event['trigger']['trpls'].some(trpls => EventCalculation.isMatchedTrigger(trpls['pids_chain'], pids));

    if (!isMatched) isMatched = EventCalculation.isMatchedWithPidChainsInMacro(event, pids);

    return isMatched;
  };

  static isMatchedTrigger = (triggerPids, filterPids) => {
    if (!triggerPids) return;

    let isMatched;
    if (filterPids.length === 1) {//search the entire array
      isMatched = triggerPids.some(pid => filterPids.includes(pid));
    } else {//strict chain search
      isMatched = EventCalculation.isArrayStartsWithAnotherArray(triggerPids, filterPids);
    }

    return isMatched;
  };

  static isMatchedPredicateMacros = (event, pids) => {
    let isMatched = pids.length === 1 && event['subscriber'] === +pids[0];
    if (!isMatched) isMatched = EventCalculation.isMatchedWithPidChainsInMacro(event, pids);
    return isMatched;
  };

  static isArrayStartsWithAnotherArray = (arrayOriginal, arrayToMatch) => {
    if (!arrayToMatch.length) return false;
    for (let index in arrayToMatch) {
      if (+arrayOriginal[+index] !== +arrayToMatch[+index]) return false;
    }
    return true;
  }

  static isMatchedWithPidChainsInMacro = (event, pids) => {
    if (!event.pid_chains_in_macro) return;
    let isMatched;

    if (pids.length === 1) {
      isMatched = event.pid_chains_in_macro.some(pidChain => pidChain.some(pid => pids.includes(pid)));
    } else {
      for (let pidChain of event.pid_chains_in_macro) {
        isMatched = EventCalculation.isArrayStartsWithAnotherArray(pidChain, pids);
        if (isMatched) break;
      }
    }

    return isMatched;
  }
}
